import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ProfitLossAccount.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClients } from '../store/clientsSlice';
import { buildAuthHeaders, getAccessToken } from '../utils/authHeaders';
const apiUrl = process.env.REACT_APP_API_URL;
const ProfitLossAccount = () => {
  const dispatch = useDispatch();
  const { clientId, financialYear } = useSelector((state) => state.app);
  const accessToken = useSelector((state) => state.auth.access_token);
  const [error,setError]=useState('');

  const [data, setData] = useState(null);

  useEffect(() => {
    dispatch(fetchClients());
    axios.get(`${apiUrl}/api/profitloss/generate`,{
      params: {
        clientId,
        financialYear
      },
      headers: buildAuthHeaders(getAccessToken(accessToken))
    })
      .then(res => {
        setData(res.data);
        setError('');
      })
      .catch(err => {
        console.error('Error fetching profit and loss account', err);
        setError(err.response?.data?.[0]?.message || 'Error fetching profit and loss account.');
      });
  }, [accessToken, dispatch,clientId,financialYear]);
  const handleFetchData = () => {
    axios.get(`${apiUrl}/api/profitloss/generate`, {
      params: {
        clientId,
        financialYear
      },
      headers: buildAuthHeaders(getAccessToken(accessToken))
    })
      .then(res => {
        setData(res.data);
        setError('');
      })
      .catch(err => {
        console.error('Error fetching profit and loss account', err);
        setError('Error fetching data from API.');
      });
  };
  return (
    <div className="profit-loss-page">
      <h2>Profit & Loss Account Statement</h2>
      <p className="financial-page-subtitle">Present income and expense statements with the same shell, table rhythm, and action treatment used elsewhere.</p>
      <div className="filters">
        <button className="financial-button" onClick={handleFetchData}>Fetch Data</button>
      </div>
      {error && <p className="financial-message financial-message--error">{error}</p>}
      {data && (
        <div className="table-container">
          <table className="profit-loss-table">
            <thead>
              <tr>
                <th>Expenses</th>
                <th>Amount</th>
                <th>Revenue</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {data.Expenses && data.Revenue && Object.keys(data.Expenses).map((key, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td colSpan="2"><strong>{key}</strong></td>
                    <td colSpan="2"><strong>{Object.keys(data.Revenue)[index]}</strong></td>
                  </tr>
                  {Object.keys(data.Expenses[key]).map((subKey, subIndex) => (
                    <tr key={subIndex}>
                      <td style={{ paddingLeft: '20px' }}>{subKey}</td>
                      <td style={{ paddingLeft: '20px' }}>{data.Expenses[key][subKey]}</td>
                      <td style={{ paddingLeft: '20px' }}>{Object.keys(data.Revenue[Object.keys(data.Revenue)[index]])[subIndex]}</td>
                      <td style={{ paddingLeft: '20px' }}>{data.Revenue[Object.keys(data.Revenue)[index]][Object.keys(data.Revenue[Object.keys(data.Revenue)[index]])[subIndex]]}</td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
              <tr>
                <td colSpan="1">Total Expenses: </td><td>{data.totalExpense}</td>
                <td colSpan="1">Total Revenue: </td><td>{data.totalRevenue}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ProfitLossAccount;